import './card-news.scss';

export default () => {

};
